import React from 'react'
import NavLink from '../Routes/NavLink'

import { tenants } from '../../core/controllers/tenants'

export default class CommunityBoard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            communityMessage: ''
        }
    }

    componentDidMount() {
        var self = this;
        tenants.getCommunityBoard(function(response) {
            self.setState({
                communityMessage: response.data
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    handleCommunityMessageChange(e) {
        this.setState({
            communityMessage: e.target.value
        });
    }

    handleUpdateMessage() {
        tenants.updateCommunityBoard(this.state);
    }

    render(){
        const communityMessage = this.state.communityMessage;
        var column = '12';
        if(this.props.column) {
            column = this.props.column;
        }

        if(!this.props.showEdit) {
            return (
                <div class={"col-md-" + column}>
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Community Message</h4>
                            <p class="category">Here is what your tenants are seeing when they log in.</p>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div class="col-md-12">
                                    <textarea rows="4" disabled cols="80" class="form-control" placeholder="Let your tenants know what is going on." value={communityMessage} onChange={this.handleCommunityMessageChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="footer">
                                <hr/>
                                <div class="legend">
                                    <NavLink to={"/tenants/"}>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" >
                                    Edit Message
                                    </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="content">
                    <div class="row">
                        <div class={"col-md-" + column}>
                            <div class="form-group">
                                <label for="email">Community Message</label>
                                <textarea rows="4" cols="80" class="form-control" placeholder="Let your tenants know what is going on." value={communityMessage} onChange={this.handleCommunityMessageChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <button type="button" id="save-message" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleUpdateMessage.bind(this)}>
                            Update Message
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/CommunityBoard.jsx